import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CRMOportunidadeAnexo } from 'src/app/models/crm/crmoportunidade-anexo';
import { TipoArquivo } from 'src/app/models/enum';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmoportunidadeAnexoService } from 'src/app/services/crm/crmoportunidade-anexo.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';

@Component({
  selector: 'app-cadastrar-oportunidade-anexo',
  templateUrl: './cadastrar-oportunidade-anexo.component.html',
  styleUrls: ['./cadastrar-oportunidade-anexo.component.scss']
})
export class CadastrarOportunidadeAnexoComponent implements OnInit {
  // variáveis
  idCRMOportunidadeAnexo;
  idOportunidade;
  oportunidadeAnexo = new CRMOportunidadeAnexo();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  public config: PerfectScrollbarConfigInterface = {};
  selectedFile: File;
  nomeArquivoBanco = '';

  constructor(
    private notificacaoService: NotificacaoService, private arquivoService: ArquivoService,
    private oportunidadeAnexoService: CrmoportunidadeAnexoService, public dialog: MatDialog,
    private carregandoService: CarregandoService, private utilitarioService: UtilitarioService, 
    public dialogRef: MatDialogRef<CadastrarOportunidadeAnexoComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.idCRMOportunidadeAnexo = data.id;
    this.idOportunidade = data.idOportunidade;
  }

  ngOnInit() {
    // se for edição, busca o oportunidadeAnexo do id passado
    if (this.idCRMOportunidadeAnexo) {
      this.editando = true;
      this.buscarCRMOportunidadeAnexo();
    } else {
      this.oportunidadeAnexo = new CRMOportunidadeAnexo();
      this.oportunidadeAnexo.arquivo = '';
      this.atualizaDadosCRMOportunidadeAnexo();
    }
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarCRMOportunidadeAnexo() {
    this.carregandoService.mostra('buscaCRMOportunidadeAnexo');

    this.oportunidadeAnexoService.consultarPorIdOportunidadeAnexo(this.idCRMOportunidadeAnexo).subscribe(tipo => {
      this.oportunidadeAnexo = tipo;
      this.nomeArquivoBanco = this.oportunidadeAnexo.arquivo;
      this.atualizaDadosCRMOportunidadeAnexo();
    }, (erro) => {
      this.carregandoService.esconde('buscaCRMOportunidadeAnexo');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosCRMOportunidadeAnexo() {
    this.carregando = false;

    this.carregandoService.esconde('buscaCRMOportunidadeAnexo');
  }

  salvar() {
    this.carregandoService.mostra('salvaCRMOportunidadeAnexo');

    this.oportunidadeAnexo.idOportunidade = Number(this.idOportunidade);

    const dados = new FormData();
    if (this.selectedFile) {
      dados.append('arquivo_consulta', this.selectedFile);
      dados.append('arqui[arquivo]', this.selectedFile.name);
    } else {
      dados.append('arqui[arquivo]', this.oportunidadeAnexo.arquivo);
    }

    dados.append('arqui[id]', this.oportunidadeAnexo.id ? this.oportunidadeAnexo.id.toString() : '0');
    dados.append('arqui[descricao]', this.oportunidadeAnexo.descricao);
    dados.append('arqui[idOportunidade]', this.idOportunidade);
    dados.append('arqui[idAnexo]', this.oportunidadeAnexo.idAnexo ? this.oportunidadeAnexo.idAnexo.toString() : '0');

    this.oportunidadeAnexoService.salvar(dados).subscribe(() => {
      this.notificacaoService.sucesso('Anexo salvo com sucesso!!!');
      this.carregandoService.esconde('salvaCRMOportunidadeAnexo');
      this.dialogRef.close(true);

    }, (erro) => {
      this.carregandoService.esconde('salvaCRMOportunidadeAnexo');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {}

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  baixarArquivo() {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(this.idCRMOportunidadeAnexo, TipoArquivo.OportunidadeAnexo).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, this.nomeArquivoBanco);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.oportunidadeAnexo.arquivo = '';
  }
}